import { Component } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DocumentFormBase } from '../document-form.base';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { OuiDatePicker, OuiValidationError } from 'omnium-ui/form-field';
import moment from 'moment';

@Component({
  selector: 'app-document-form-cerfa-3666',
  standalone: true,
  imports: [OuiDatePicker],
  templateUrl: './document-form-cerfa-3666.component.html',
  styleUrl: './document-form-cerfa-3666.component.scss',
})
export class DocumentFormCerfa3666Component extends DocumentFormBase<Cerfa3666Form> {
  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  override createForm(fb: NonNullableFormBuilder) {
    return createCerfa3666Form(fb);
  }

  setDateFinDeValidite(newDate: moment.Moment | string | null) {
    if (newDate != null && typeof newDate != 'string') {
      const dateFinCerfa3666 = moment(newDate).add(6, 'months').toDate();
      const newDateFin = newDate ? dateFinCerfa3666 : undefined;

      this.form.get('dateFinValidite')?.setValue(newDateFin);
    }
  }
}

export function createCerfa3666Form(fb: NonNullableFormBuilder) {
  return fb.group({
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
    dateFinValidite: fb.control<Date | undefined>(undefined),
  });
}

export type Cerfa3666Form = ReturnType<typeof createCerfa3666Form>;
export type Cerfa3666FormValue = Cerfa3666Form['value'];
